import * as React from "react"
import {DropdownProps, Form, Loader} from "semantic-ui-react"
import {Locale} from "../model/BookingTypes"
import {LocaleFragment, Locales as LOCALES} from "../graphql/queries"
import {GraphQL} from "../graphql"

interface OwnProps {
  disabled: boolean
  locale: LocaleFragment
  onLocale: (locale: LocaleFragment) => void
}

type Props = OwnProps & LocalesProp

function localesOptions(locales: Array<Locale>) {
  return locales.map((locale: Locale) => ({
    key: locale.id,
    text: locale.label,
    value: locale.id,
  }))
}

class Locales extends React.Component<Props> {
  onSelectLocale = (event: React.SyntheticEvent<HTMLElement>, field: DropdownProps) => {
    const {locales, onLocale} = this.props
    if (locales) {
      const localeId = field.value
      const locale = locales.find((it: Locale) => it.id === localeId)
      if (locale) {
        onLocale(locale)
      }
    }
  }

  render() {
    const {locale, locales, disabled} = this.props

    return (
      <Form.Dropdown
        disabled={disabled}
        name="locales"
        selection
        search={true}
        onChange={this.onSelectLocale}
        value={locale.id}
        options={localesOptions(locales)}
      />
    )
  }
}

interface LocalesProp {
  locales: Array<Locale>
}

function WithLocales(props: OwnProps) {
  return (
    <GraphQL.Query
      query={LOCALES}
      variables={{}}
      render={({data}) => {
        if (data) {
          return <Locales {...props} locales={data.locales || []} />
        } else {
          return <Loader active />
        }
      }}
    />
  )
}

export {WithLocales as Locales}



// WEBPACK FOOTER //
// ./src/components/Locales.tsx